import {createReducer, on} from '@ngrx/store';
import {AvailablePersistentAddresses} from '../../../services/api/account/persistent-addresses/persistent-address.model';
import {
  clearOrganizationPersistentAddressesState,
  loadOrganizationPersistentAddresses,
  loadOrganizationPersistentAddressesFailure,
  loadOrganizationPersistentAddressesSuccess
} from './organization-account.persistent-addresses.actions';
import {RegionCode} from '../../../services/api/account/regions/region.model';


export interface State {
  record: AvailablePersistentAddresses | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
  region: RegionCode | null;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
  region: null
};


export const loadOrganizationPersistentAddressesReducer = createReducer(
  initialState,

  on(loadOrganizationPersistentAddresses, (state: State, action: { region: RegionCode }): State => ({
    record: state.record,
    error: null,
    loaded: false,
    loading: true,
    region: action.region
  })),
  on(loadOrganizationPersistentAddressesSuccess, (state: State, action: { data: AvailablePersistentAddresses }): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
    region: state.region
  })),
  on(loadOrganizationPersistentAddressesFailure, (state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
    region: state.region
  })),
  on(clearOrganizationPersistentAddressesState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
    region: null
  }))
);
